import AlertComponent from "components/molecules/Alert/Alert";
import { SuccessMessages } from "constants/global";
import { useAlert } from "containers/Alert/useAlert";

const AlertPage = () => {
	const componentProps = useAlert();
	const { type } = componentProps;

	if (!type) {
		return <></>;
	}

	return <>{type === "login" && <AlertComponent title={SuccessMessages?.LOGGED_IN} />}</>;
};

export default AlertPage;
